"use strict";
const MAX_TEXTURES = 16;

export { MAX_TEXTURES };
//# sourceMappingURL=const.mjs.map
